import { useTheme } from '@mui/material/styles';
import NoBookedIcon from './no_booked';
import SomeBookedIcon from './some_booked';
import AllBookedIcon from './all_booked';
import SomeBookedWarnIcon from './some_booked_warn';
import AllBookedWarnIcon from './all_booked_warn';
import ExpandedNoBookedIcon from './expanded_no_booked';
import ExpandedSomeBookedIcon from './expanded_some_booked';
import ExpandedAllBookedIcon from './expanded_all_booked';
import ExpandedSomeBookedWarnIcon from './expanded_some_booked_warn';
import ExpandedAllBookedWarnIcon from './expanded_all_booked_warn';

export default function FeaturesStatusIcon({
  state,
  expanded,
  width,
  height,
}: {
  state: 'no_booked' | 'some_booked' | 'all_booked' | 'some_booked_warn' | 'all_booked_warn';
  expanded: boolean;
  width?: number;
  height?: number;
}) {
  const theme = useTheme();
  const iconSize = width || height || 24;

  // Theme colors
  const primaryColor = theme.palette.primary.main;
  const activeColor = theme.palette.action.active;
  const errorColor = theme.palette.error.main;
  const whiteColor = theme.palette.common.white;

  switch (state) {
    case 'no_booked':
      return expanded ? (
        <ExpandedNoBookedIcon width={iconSize} height={iconSize} activeColor={activeColor} whiteColor={whiteColor} />
      ) : (
        <NoBookedIcon width={iconSize} height={iconSize} primaryColor={primaryColor} activeColor={activeColor} />
      );
    case 'some_booked':
      return expanded ? (
        <ExpandedSomeBookedIcon
          width={iconSize}
          height={iconSize}
          primaryColor={primaryColor}
          activeColor={activeColor}
          whiteColor={whiteColor}
        />
      ) : (
        <SomeBookedIcon width={iconSize} height={iconSize} primaryColor={primaryColor} activeColor={activeColor} />
      );
    case 'all_booked':
      return expanded ? (
        <ExpandedAllBookedIcon width={iconSize} height={iconSize} primaryColor={primaryColor} whiteColor={whiteColor} />
      ) : (
        <AllBookedIcon width={iconSize} height={iconSize} primaryColor={primaryColor} />
      );
    case 'some_booked_warn':
      return expanded ? (
        <ExpandedSomeBookedWarnIcon
          width={iconSize}
          height={iconSize}
          primaryColor={primaryColor}
          activeColor={activeColor}
          errorColor={errorColor}
          whiteColor={whiteColor}
        />
      ) : (
        <SomeBookedWarnIcon
          width={iconSize}
          height={iconSize}
          primaryColor={primaryColor}
          activeColor={activeColor}
          errorColor={errorColor}
        />
      );
    case 'all_booked_warn':
      return expanded ? (
        <ExpandedAllBookedWarnIcon
          width={iconSize}
          height={iconSize}
          primaryColor={primaryColor}
          errorColor={errorColor}
          whiteColor={whiteColor}
        />
      ) : (
        <AllBookedWarnIcon width={iconSize} height={iconSize} primaryColor={primaryColor} errorColor={errorColor} />
      );
    default:
      return null;
  }
}
